import React,{useEffect} from 'react'
import {
    Divider,
    List,
    ListItem,
    ListItemText,
    ListSubheader,
    ListItemIcon,
    Box,
    CircularProgress,
  } from "@mui/material";
  import genreIcons from "../../assets/genres"
import {Link} from "react-router-dom"
import { useDispatch,useSelector } from 'react-redux';
import {useTheme} from "@mui/styles"
import useStyles from './styles'
import {useGetGenresQuery} from "../../services/TMDB"
import {  selectGenreOrCategory } from '../../features/currentGenreOrCategory';

const redLogo =
  "https://fontmeme.com/permalink/210930/8531c658a743debe1e1aa1a2fc82006e.png";
const blueLogo =
  "https://fontmeme.com/permalink/210930/6854ae5c7f76597cf8680e48a2c8a50a.png";


  const categories = [
    {label:'Popular',value:'popular'},
    {label:'Top Rated',value:'top_rated'},
    {label:'Upcoming',value:'upcoming'},
  ]


const Sidebar = ({setMobileopen}) => {
    const theme = useTheme();
    const classes = useStyles();
  
    const dispatch = useDispatch();
    const {genreIdOrCategoryName} = useSelector((state)=>state.currentGenreOrCategory);
    const {data,isFetching} = useGetGenresQuery({genreIdOrCategoryName});

  return (
    <>
    <Link to="/" className={classes.imageLink}>
    <img className={classes.image} src={theme.palette.mode ==='light' ? redLogo :blueLogo} alt="Filmpire Logo" />

    </Link>
    <Divider />
    <List>
        <ListSubheader>
            categories
        </ListSubheader>
        {categories.map(({label,value})=>(
            <Link key={value} className={classes.links} to="/">
                <ListItem onClick={()=>dispatch(selectGenreOrCategory(value))} button>
                <ListItemIcon>
                    <img src={genreIcons[label.toLowerCase()]} className={classes.genereImages} height={30}/>
                </ListItemIcon>
                <ListItemText primary={label} />
                

                </ListItem>
            </Link>
         

        ))}
    </List>
    <Divider />


    <List>
        <ListSubheader>
            Genres
        </ListSubheader>
        {isFetching ?(
          <Box display="flex" justifyContent="center">
        <CircularProgress size="4rem" />
      </Box>

        ):
          data.genres.map(({name,id})=>(
            <Link key={id} className={classes.links} to="/">
                <ListItem onClick={()=>dispatch(selectGenreOrCategory(id))} button>
                <ListItemIcon>
                    <img src={genreIcons[name.toLowerCase()]} className={classes.genereImages} height={30}/>
                </ListItemIcon>
                <ListItemText primary={name} />
                     
                </ListItem>
            </Link>
         

        ))}
    </List>
    <Divider />
    </>
  )
}

export default Sidebar